<template>
  <div
    id="canvas-container-animation-spine-seasonpass-unlock-level"
    ref="canvascontainer"
    :style="{ opacity: containerOpacity }"
    class="canvas-container-animation-spine-seasonpass-unlock-level"
  ></div>
</template>

<script>
import AnimationSpineBaseFunctions from "@/components/animation/animation-spine-base-functions";
import sound_super_win from "@/assets/sound/animation/adelsliga-aufstieg-fanfare.mp3";

export default {
  name: "AnimationSeasonpassUnlockLevel",
  mixins: [AnimationSpineBaseFunctions],
  props: {
    loop: {
      type: Boolean,
      default: true,
    },
    run: {
      type: Boolean,
      default: true,
    },
    level: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      containerId: "canvas-container-animation-spine-seasonpass-unlock-level",
      json: "/assets/spines/events/winterbonusjagd/winterbonusjagd-unlocklevel.json",
      atlas:
        "/assets/spines/events/winterbonusjagd/winterbonusjagd-unlocklevel.atlas",
    };
  },

  mounted() {
    this.setupAnimation("main", this.onSuccess);
  },

  methods: {
    onSuccess() {
      this.containerOpacity = 1;
      this.hideSnowSlots();
      //text
      let text1 = document.createElement("div");
      text1.classList.add("text1");
      text1.classList.add("to-center-abs");

      text1.innerHTML = this.$t("seasonpass.level.unlocked");
      this.$refs.canvascontainer.appendChild(text1);
      this.showText(text1);
      this.spinePlayer.animationState.addListener({
        start: () => {
          this.hideSnowSlots();
        },
        complete: () => {
          this.$emit("seasonpass-ani-completed");
        },
      });
    },

    hideSnowSlots() {
      const skeleton = this.spinePlayer && this.spinePlayer.skeleton;
      if (!skeleton || !skeleton.slots) return;
      skeleton.slots.forEach((slot) => {
        const name = (slot.data && slot.data.name) || "";
        if (/snow|schnee/i.test(name)) {
          slot.setAttachment(null);
        }
      });
    },

    showText(element) {
      const timeline = this.gsap.timeline();
      timeline
        .to(
          [element],
          0,
          {
            onComplete: () => {
              this.playSoundEffect(sound_super_win, false, 0.7);
            },
          },
          0
        )
        .fromTo(
          [element],
          0.8,
          {
            scale: 0,
          },
          {
            ease: "elastic",
            scale: 1,
          },
          1
        );
    },
  },
};
</script>

<style lang="scss">
.canvas-container-animation-spine-seasonpass-unlock-level {
  pointer-events: none;
  width: 1121px;
  height: 715px;

  canvas {
    position: absolute;
    z-index: 1000;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
  }

  .text1 {
    font-family: Ubuntu-Medium;
    color: white;
    background: none;
    text-shadow: 1px 1px 2px #1ae5f4, 0 0 25px #1ae5f4, 0 0 5px #1ae5f4 !important;
    font-size: 60px;
    top: 85%;
    -webkit-text-fill-color: white;
    transform: scale(0);
    z-index: 1001;
    width: 100%;
    text-transform: uppercase;
  }
}
</style>
